export default __webpack_public_path__ + "static/media/dryage.23eed65f.jpg";